import { FC } from 'react';

import { RaaDialog } from 'raa-react';

const ForbiddenDialog: FC = () => {
  return (
    <RaaDialog
      header="Saknar behörighet"
      proceed={() => {
        window.location.reload();
      }}
      proceedButtonText="Ladda om sidan"
      ariaDescribedBy="dialog-description"
    >
      <p id="dialog-description" className="tw-my-4">
        Din begäran kunde inte utföras
      </p>
    </RaaDialog>
  );
};

export default ForbiddenDialog;
